const application = {
  en: {
    messages: {
      request: {
        error: "There was an error completing your request, please try again."
      }
    }
  }
};

module.exports.application = application;